module.exports = __webpack_public_path__ + "static/media/soils_reports_5.7cc97ae9.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_reports_5.png
// module id = 1292
// module chunks = 0